import { ChangeDetectionStrategy, Component, OnChanges, OnInit } from '@angular/core';
import { BrandService } from '../../../../shared/services/brand/brand.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-brand-selection-dropdown',
  templateUrl: '../template-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandSelectionDropdownComponent extends DropdownBaseComponent implements OnChanges, OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    private readonly brandService: BrandService,
    protected readonly translatorService: TranslatorService,
    private leadComuService: LeadsComunicationService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.brandService.brandsQuery$(null, null).subscribe(res => {
      this.itemsData = this.itemsData.concat(res.brandList);
      this.leadComuService.brands = res.brandList;
    });
    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
  }

}
